// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-border-bottom[data-v-72ae4f0b] {\n  border-bottom: 1px solid #ececec;\n}\n.note[data-v-72ae4f0b] {\n  background-color: var(--v-background);\n}\n.align-middle-vertical[data-v-72ae4f0b] {\n  line-height: 35px;\n}", ""]);
// Exports
module.exports = exports;
